import { useQuery } from '@tanstack/react-query'

import fetchRequest from '@/app/_utils/fetch-request'
import { QueryKeys } from '@/app/_utils/react-query/query-keys'

import { IranianWomenDataViewModel } from '../types'

export const fetchIranianWomenRequest = async (isServerSideRequest: boolean) =>
    fetchRequest({
        endpoint: '/cases/iranian-women',
        method: 'GET',
        serviceName: 'cml',
        isServerSideRequest,
    })

export const useFetchIranianWomenData = () => {
    const { data, isLoading, isError } = useQuery<IranianWomenDataViewModel>({
        queryKey: QueryKeys.IranianWomenLanding.Data,
        queryFn: () => fetchIranianWomenRequest(false),
        refetchOnMount: false,
    })

    return { data, isLoading, isError }
}
